import { render, staticRenderFns } from "./PriTama04.vue?vue&type=template&id=4c5422ae&scoped=true&"
import script from "./PriTama04.vue?vue&type=script&lang=js&"
export * from "./PriTama04.vue?vue&type=script&lang=js&"
import style0 from "./PriTama04.vue?vue&type=style&index=0&id=4c5422ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5422ae",
  null
  
)

export default component.exports